module.exports = __webpack_public_path__ + "img/khairul 2.d7b659a1.png";